import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    createModuleSectionFail,
    createModuleSectionSuccess,
    deleteModuleSectionFail,
    deleteModuleSectionSuccess,
    GET_MODULE_SECTIONS_REQUEST,
    getModuleSectionsFail,
    getModuleSectionsSuccess,
    reorderModuleSectionsFail,
    reorderModuleSectionsSuccess,
    setModuleSectionLoading,
    updateModuleSectionFail,
    updateModuleSectionSuccess,
} from "../actions/moduleCleSectionActions";
import { GET_MODULECLE_CONTENTS_REQUEST } from "../actions/moduleCleContentActions";
import { API_BASE_URL, deleteRequest, extractErrorMessage, getRequest, postRequest, putRequest } from "../../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export function* getModuleSectionsSaga(action) {
    const { moduleCleId } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/sections`;

    yield put(setModuleSectionLoading(true));
    try {
        const response = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(getModuleSectionsSuccess(moduleCleId, response.data || []));
    } catch (error) {
        yield put(getModuleSectionsFail(extractErrorMessage(error, "Impossible de charger les sections du module.")));
    } finally {
        yield put(setModuleSectionLoading(false));
    }
}

export function* createModuleSectionSaga(action) {
    const { moduleCleId, payload, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/sections`;

    yield put(setModuleSectionLoading(true));
    try {
        const response = yield call(postRequest, { url, uid: getUid(), token: getToken(), data: payload });
        yield put(createModuleSectionSuccess(response.data));
        yield put({ type: GET_MODULE_SECTIONS_REQUEST, payload: { moduleCleId } });
        yield call([Swal, Swal.fire], { icon: "success", text: "Section créée.", timer: 1400, showConfirmButton: false });
        if (callbacks.onSuccess) callbacks.onSuccess(response.data);
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de créer la section.");
        yield put(createModuleSectionFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) callbacks.onError(message);
    } finally {
        yield put(setModuleSectionLoading(false));
    }
}

export function* updateModuleSectionSaga(action) {
    const { moduleCleId, sectionId, payload, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/sections/${sectionId}`;

    yield put(setModuleSectionLoading(true));
    try {
        const response = yield call(putRequest, { url, uid: getUid(), token: getToken(), data: payload });
        yield put(updateModuleSectionSuccess(response.data));
        yield put({ type: GET_MODULE_SECTIONS_REQUEST, payload: { moduleCleId } });
        yield call([Swal, Swal.fire], { icon: "success", text: "Section mise à jour.", timer: 1400, showConfirmButton: false });
        if (callbacks.onSuccess) callbacks.onSuccess(response.data);
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de modifier la section.");
        yield put(updateModuleSectionFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) callbacks.onError(message);
    } finally {
        yield put(setModuleSectionLoading(false));
    }
}

export function* deleteModuleSectionSaga(action) {
    const { moduleCleId, sectionId, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/sections/${sectionId}`;

    yield put(setModuleSectionLoading(true));
    try {
        yield call(deleteRequest, { url, uid: getUid(), token: getToken() });
        yield put(deleteModuleSectionSuccess({ moduleCleId, sectionId }));
        yield put({ type: GET_MODULE_SECTIONS_REQUEST, payload: { moduleCleId } });
        yield put({ type: GET_MODULECLE_CONTENTS_REQUEST, payload: { moduleCleId } });
        yield call([Swal, Swal.fire], { icon: "success", text: "Section supprimée.", timer: 1400, showConfirmButton: false });
        if (callbacks.onSuccess) callbacks.onSuccess();
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de supprimer la section.");
        yield put(deleteModuleSectionFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) callbacks.onError(message);
    } finally {
        yield put(setModuleSectionLoading(false));
    }
}

export function* reorderModuleSectionsSaga(action) {
    const { moduleCleId, orderedSectionIds, callbacks = {} } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${moduleCleId}/sections/reorder`;

    try {
        const response = yield call(putRequest, {
            url,
            uid: getUid(),
            token: getToken(),
            data: { orderedSectionIds },
        });
        yield put(reorderModuleSectionsSuccess(moduleCleId, response.data || []));
        if (callbacks.onSuccess) callbacks.onSuccess(response.data || []);
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de réordonner les sections du module.");
        yield put(reorderModuleSectionsFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
        if (callbacks.onError) callbacks.onError(message);
    }
}
